/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-08 17:10:50
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 20:08:27
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Switch,
  TimePicker,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { Checks, Settinglable } from '../../../../models/setting'
import morenImg from '../../../payment/confirm/assets/morenImg.png'
import bankCardIcon from '../../../payment/confirm/assets/bankCardIcon.png'
import dyIcon from '../../../payment/confirm/assets/dyIcon.png'
import dzdpIcon from '../../../payment/confirm/assets/dzdpIcon.png'
import elmIcon from '../../../payment/confirm/assets/elmIcon.png'
import hykfxIcon from '../../../payment/confirm/assets/hykfxIcon.png'
import kjlIcon from '../../../payment/confirm/assets/kjlIcon.png'
import mtIcon from '../../../payment/confirm/assets/mtIcon.png'
import mtISmallcon from '../../../payment/confirm/assets/mtISmallcon.png'
import tbIcon from '../../../payment/confirm/assets/tbIcon.png'
import upsizedIcon from '../../../payment/confirm/assets/upsizedIcon.png'
import xhsIcon from '../../../payment/confirm/assets/xhsIcon.png'
import xykIcon from '../../../payment/confirm/assets/xykIcon.png'
import ybIcon from '../../../payment/confirm/assets/ybIcon.png'
import yhqIcon from '../../../payment/confirm/assets/yhqIcon.png'
import yhqTwoIcon from '../../../payment/confirm/assets/yhqTwoIcon.png'
import {
  getPaymentWayListAddOrEditSubmit,
  getPaymentWayListDelete,
} from '../../../payment/confirm/paymentConfirmSlice'
import {
  getSettingDetail,
  selectSettings,
  selectTenant,
} from '../../../user/setting/settingSlice'
import styles from '../../functionSettingTabs.module.css'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons'
import { ChargeSetting, getIconImg } from '../../../../models/payment'
import { getPrintTemplateSettingList } from '../../../print/printSlice'
import { selectTenantAreaCd } from '../../../../app/applicationSlice'
import { getFeesSettingAsync, getSaveFeesSettingAsync } from './feeSettingSlice'
import { invoiceSaveAsync } from '../../../tenant/tenantSlice'

export const FeeSettings = (props: {
  selectedTab?: any
  membersStatus?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()
  const [invoiceForm] = Form.useForm()

  const { Option } = Select

  const inputRef = useRef<Input>(null)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const code = tenantAreaCd?.slice(0, 4)

  const [printFlag, setPrintFlag] = useState<any>(false)

  const [templateList, setTemplateList] = useState<any>()

  const [invoiceNumberViewA, setInvoiceNumberViewA] = useState('')
  const [invoiceNumberViewB, setInvoiceNumberViewB] = useState('')
  const [invoiceSettingVisible, setInvoiceSettingVisible] = useState(false)
  const [invoiceSettingLoading, setInvoiceSettingLoading] = useState(false)

  const JuheShow: any = useSelector(selectTenant) //是否显示聚合支付按钮/type

  const [addPayTypeFlag, setAddPayTypeFlag] = useState(false)

  const [addValue, setAddValue] = useState<any>() //添加时的值

  const [paymentWayList, setPaymentWayList] = useState<any>()

  const [iconType, setIconType] = useState<any>() //icon选择框选中哪个的type

  const [selectIcon, setSelectIcon] = useState<any>() //选中的icon的id

  const [openVisible, setOpenVisible] = useState(false) //打开icon选择框

  const [openEditName, setOpenEditName] = useState(false) //是否打开编辑支付方式的文字以及icon

  const [openEditId, setOpenEditId] = useState<any>() //编辑文字时的id

  const [addOrEditFlag, setAddOrEditFlag] = useState<any>() //添加或者保存的标志

  const [formChangeCheckBox, setFormChangeCheckBox] = useState<any>() // 记录checkbox变化后的值

  const [selectResultLists, setSelectResultLists] = useState<any>()

  const [morenPayWayListData, setMorenPayWayListData] = useState<any>() //默认支付方式根据选中的支付方式来

  const [modalSelectIconType, setModalSelectIconType] = useState<any>('')

  const [buttonLoading, setButtonLoading] = useState(false)

  const settings = useSelector(selectSettings)

  const [payList, setPayList] = useState<any>()

  const [data, setData] = useState([])

  const [systemPayMethods, setSystemPayMethods] = useState<any>([])

  // 发票
  useEffect(() => {
    if (props?.selectedTab == '4') {
      getPage()
    }
  }, [props?.selectedTab])

  const refreshInvoiceNumberView = () => {
    const anumber = invoiceForm.getFieldValue('acurrent')
    const ainvoiceNumberLength = invoiceForm.getFieldValue('ainvoiceNumberLength')
    const bnumber = invoiceForm.getFieldValue('bcurrent')
    const binvoiceNumberLength = invoiceForm.getFieldValue('binvoiceNumberLength')
    if (anumber) {
      if (
        !ainvoiceNumberLength ||
        ainvoiceNumberLength <= 0 ||
        ainvoiceNumberLength <= anumber.length ||
        ainvoiceNumberLength > 15
      ) {
        setInvoiceNumberViewA(anumber)
      } else {
        const diffLength = ainvoiceNumberLength - anumber.length
        let Azero = ''
        for (let i = 0; i < diffLength; i++) {
          Azero += '0'
        }
        setInvoiceNumberViewA(Azero + '' + anumber)
      }
    } else {
      setInvoiceNumberViewA('')
    }

    if (bnumber) {
      if (
        !binvoiceNumberLength ||
        binvoiceNumberLength <= 0 ||
        binvoiceNumberLength <= bnumber.length ||
        binvoiceNumberLength > 15
      ) {
        setInvoiceNumberViewB(bnumber)
      } else {
        const diffLength = binvoiceNumberLength - bnumber.length
        let Bzero = ''
        for (let i = 0; i < diffLength; i++) {
          Bzero += '0'
        }
        setInvoiceNumberViewB(Bzero + '' + bnumber)
      }
    } else {
      setInvoiceNumberViewB('')
    }
  }

  const getPage = () => {
    dispatch(getFeesSettingAsync())
      .then(unwrapResult)
      .then((res: any) => {
        const FPXZData = res?.functions?.filter((v: any) => v?.type == 42)?.[0]

        dispatch(getPrintTemplateSettingList({ current: 1, size: 500 }))
        .then(unwrapResult)
        .then((v: any) => {
          const data = v?.map((i: any) => {
            return { ...i, templateId: i?.templateId?.toString() }
          })
          setTemplateList(data?.filter((v: any) => v?.state == 1))
          const templateListIds = data?.filter((v: any) => v?.state == 1)?.map((v: any) => v?.templateId)

          const FPXZValue = FPXZData?.value

          const FPXZValueId = FPXZData?.value ? FPXZData?.value?.split(',') : []

          const existingNumbers = FPXZValueId?.length
          ? FPXZValueId?.filter((num: any) =>
            templateListIds?.includes(num)
          )?.join(',')
          : FPXZValue

          form.setFieldsValue({
            [Checks.FPXZ]: existingNumbers
            ? existingNumbers?.split(',').map(String)
            : [],
          })
        })
        const MrzffsData = res?.functions?.filter((v: any) => v?.type == 7)?.[0]

        const JEMLData = res?.functions?.filter((v: any) => v?.type == 31)?.[0]
        
        const JYYSKQData = res?.functions?.filter((v: any) => v?.type == 49)?.[0]

        setPrintFlag(FPXZData?.value ? true : false)
        form.setFieldsValue({
          [Checks.Mrzffs]: Number(MrzffsData?.value),
          [Checks.JEML]: JEMLData?.value == 'true' ? true : false,
          [Checks.JYYSKQ] :JYYSKQData?.value 
        })

        const invoiceNumberConfigs = res?.invoiceNumberConfigs || []
        const a = invoiceNumberConfigs.length
          ? invoiceNumberConfigs.find((v: any) => v.categoryType == 0)
          : {}
        const b = invoiceNumberConfigs.length
          ? invoiceNumberConfigs.find((v: any) => v.categoryType == 1)
          : {}
        invoiceForm.setFieldsValue({
          aCode: a.invoiceCode,
          ano: {
            astart: a.start,
            aend: a.end,
          },
          ainvoiceNumberLength:
            a.invoiceNumberLength && a.invoiceNumberLength > 0
              ? a.invoiceNumberLength
              : 0,

          acurrent: a.currentNo,
          bCode: b.invoiceCode,
          bno: {
            bstart: b.start,
            bend: b.end,
          },
          bcurrent: b.currentNo,
          binvoiceNumberLength:
            b.invoiceNumberLength && b.invoiceNumberLength > 0
              ? b.invoiceNumberLength
              : 0,
        })

        setData(invoiceNumberConfigs.length ? invoiceNumberConfigs : [])

        const tenantSystemPayMethods = res?.tenantSystemPayMethods || []
        const tenantCustomizePayMethods = res?.tenantCustomizePayMethods || []
        setSystemPayMethods(tenantSystemPayMethods)
        getPaymentWayModalList(tenantSystemPayMethods, tenantCustomizePayMethods)

        refreshInvoiceNumberView()
      })
  }

  const required = {
    rules: [
      {
        required: true,
      },
      {
        pattern: /^\d+$/,
        message: '请输入正确数字',
      },
    ],
  }

  const numberRules = {
    rules: [
      {
        pattern: /^\d+$/,
        message: '请输入正确数字',
      },
    ],
  }

  const handleInvoiceSettingFinish = (values: any) => {
    if (values.ano.astart - values.ano.aend >= 0) {
      notification.info({
        message: '收费发票起始号码须大于结束号码',
      })
      return
    }
    if (values.acurrent - values.ano.aend >= 0) {
      notification.info({
        message: '收费发票当前号码须小于收费发票结束号码',
      })
      return
    }
    if (values.bno?.bstart && values.bno?.bend) {
      if (values.bno.bstart - values.bno.bend >= 0) {
        notification.info({
          message: '挂号发票起始号码须大于结束号码',
        })
        return
      }
      if (values.bcurrent - values.bno.bend >= 0) {
        notification.info({
          message: '挂号发票当前号码须小于收费发票结束号码',
        })
        return
      }
    }
    const a: any = data.length
      ? data.find((v: any) => v.categoryType == 0)
      : {}
    const b: any = data.length
      ? data.find((v: any) => v.categoryType == 1)
      : {}
    const invoiceNumberConfigs = [
      {
        categoryType: '0',
        currentNo: values.acurrent,
        start: values.ano.astart,
        end: values.ano.aend,
        invoiceCode: values.aCode,
        id: a ? a.id : undefined,
        invoiceNumberLength: values.ainvoiceNumberLength,
      },
      {
        categoryType: '1',
        currentNo: values.bcurrent,
        start: values.bno.bstart,
        end: values.bno.bend,
        invoiceCode: values.bCode,
        id: b ? b.id : undefined,
        invoiceNumberLength: values.binvoiceNumberLength,
      },
    ]

    setInvoiceSettingLoading(true)
    dispatch(invoiceSaveAsync(invoiceNumberConfigs))
      .then(unwrapResult)
      .then(() => {
        notification.success({
          message: '保存成功',
        })
        setInvoiceSettingVisible(false)
        getPage()
      })
      .finally(() => {
        setInvoiceSettingLoading(false)
      })
  }

  // 支付方式
  useEffect(() => {
    {
      setPayList([
        {
          name: '现金',
          value: '1',
        },
        {
          name: '微信',
          value: '4',
        },

        {
          name: '支付宝',
          value: '3',
        },
        JuheShow?.openHubPay == 1 ||
        JuheShow?.openHubPayJiali == 1 ||
        JuheShow?.openHubPayYinlian == 1 ||
        JuheShow?.openHubPayKanglin == 1 ||
        JuheShow?.openHubPayNew == 1
          ? {
              name: '聚合支付',
              value: '2',
            }
          : '',
        {
          name: '银联',
          value: '5',
        },
        props?.membersStatus != 0
          ? {
              name: '会员',
              value: '6',
            }
          : '',
      ])
    }
  }, [JuheShow, props?.membersStatus])

  const iconList = [
    { img: ybIcon, type: 'ybIcon', width: '44px', height: '44px', id: 1 },
    {
      img: mtISmallcon,
      type: 'mtISmallcon',
      width: '44px',
      height: '44px',
      id: 2,
    },
    { img: dyIcon, type: 'dyIcon', width: '34px', height: '34px', id: 3 },
    { img: elmIcon, type: 'elmIcon', width: '48px', height: '48px', id: 4 },
    { img: dzdpIcon, type: 'dzdpIcon', width: '44px', height: '44px', id: 5 },

    { img: xhsIcon, type: 'xhsIcon', width: '40px', height: '40px', id: 6 },
    {
      img: mtIcon,
      type: 'mtIcon',
      width: '46px',
      height: '46px',
      id: 7,
    },
    { img: xykIcon, type: 'xykIcon', width: '46px', height: '46px', id: 8 },
    { img: yhqIcon, type: 'yhqIcon', width: '41px', height: '41px', id: 9 },
    { img: tbIcon, type: 'tbIcon', width: '38px', height: '38px', id: 10 },

    {
      img: hykfxIcon,
      type: 'hykfxIcon',
      width: '45px',
      height: '45px',
      id: 11,
    },
    { img: kjlIcon, type: 'kjlIcon', width: '40px', height: '40px', id: 12 },
    {
      img: yhqTwoIcon,
      type: 'yhqTwoIcon',
      width: '46px',
      height: '46px',
      id: 13,
    },
    {
      img: bankCardIcon,
      type: 'bankCardIcon',
      width: '42px',
      height: '42px',
      id: 14,
    },
    {
      img: upsizedIcon,
      type: 'upsizedIcon',
      width: '50px',
      height: '50px',
      id: 15,
    },
  ]

  const getMethodName = (v: any) => {
    if (v == '1') {
      return '现金'
    } else if (v == '3') {
      return '支付宝'
    } else if (v == '4') {
      return '微信'
    } else if (v == '2') {
      return '聚合支付'
    } else if (v == '5') {
      return '银联'
    } else if (v == '6') {
      return '会员'
    }
  }

  useEffect(() => {
    if (props?.selectedTab != '4') {
      form.resetFields()
      // 默认只有一个添加按钮,点击后展示添加的输入框
      setAddPayTypeFlag(false)
      // 新增或添加每点击时是关闭
      setAddOrEditFlag(false)
      // 默认关闭编辑文字框
      setOpenEditName(false)
      setSystemPayMethods([])
    }
  }, [props?.selectedTab])

  useEffect(() => {
    if (paymentWayList?.length) {
      // formChangeCheckBox 是一个对象要转化为数组对象，然后过滤没选中的checkbox，拿到id,跟全部的匹配
      // 选中的支付方式需要在默认支付方式展示
      const selectCheckboxObject: any = []
      for (const v in formChangeCheckBox) {
        selectCheckboxObject.push({
          id: parseInt(v),
          value: formChangeCheckBox[v],
        })
      }

      // 过滤没选中的值,拿到选中的id
      const selectId = selectCheckboxObject
        ?.filter((v: any) => v?.value == true)
        ?.map((item: any) => item.id)

      const morenPayWayList = paymentWayList.filter((i: any) =>
        selectId.includes(i.id)
      )
      setMorenPayWayListData(morenPayWayList)
    }
  }, [formChangeCheckBox, paymentWayList])

  const getPaymentWayModalList = (sysPayMethodsParam?: any[], customPayMethodsParam?: any[]) => {
    const sysPayMethods = sysPayMethodsParam ?? systemPayMethods
    const customPayMethods = customPayMethodsParam ?? paymentWayList

    setPaymentWayList(customPayMethods || [])

    const systemPayMethodMap: Record<string, boolean> = {}
    sysPayMethods?.forEach((spm: any) => {
      systemPayMethodMap[String(spm.methodType)] = spm.status === 1
    })
    const mergedObject: any = {
      '1': systemPayMethodMap['1'] ?? true,
      '3': systemPayMethodMap['3'] ?? true,
      '4': systemPayMethodMap['4'] ?? true,
      '5': systemPayMethodMap['5'] ?? true,
      '6': props?.membersStatus != 0 ? (systemPayMethodMap['6'] ?? true) : false,
    }
    customPayMethods?.forEach((item: any) => {
      mergedObject[Number(item.id)] = item.status == 1
    })

    setFormChangeCheckBox(mergedObject)

    form.setFieldsValue({ ...mergedObject })
  }

  const addOrEditPaymentWay = (v?: any) => {
    // 转化获取到的保存的值
    const result: any = []
    const submitData = form.getFieldsValue()
    for (const v in submitData) {
      result.push({ id: parseInt(v), value: submitData[v] })
    }
    const submitStatus = result?.filter((v: any) => v?.id)
    const status = submitStatus?.find((v: any) => v?.id == openEditId)?.value
    const methodIcon = iconList?.find((v) => v?.type == iconType)?.type
    const commonParam = {
      methodName: addValue,
      methodIcon: methodIcon,
    }
    const params = openEditId
      ? {
          ...commonParam,
          id: openEditId,
          status: status ? 1 : 0,
        }
      : {
          ...commonParam,
          status: 0,
        }
    if (addValue && methodIcon) {
      dispatch(getPaymentWayListAddOrEditSubmit({ ...params }))
        .then(unwrapResult)
        .then((v) => {
          setAddPayTypeFlag(false)
          setAddOrEditFlag(false)
          setOpenEditName(false)
          setIconType('')
          notification.success({
            message: '操作成功',
            duration: 1,
            onClose: () => {
              getPage()
            },
          })
        })
    } else {
      notification.info({
        message: '请填写支付方式并选择图片',
        duration: 1,
        onClose: () => {
          setAddOrEditFlag(false)
        },
      })
    }
  }

  useEffect(() => {
    if (addOrEditFlag) {
      addOrEditPaymentWay()
    }
  }, [addOrEditFlag, openEditId, addValue, iconType])

  const content = (
    <div style={{ display: 'flex', flexDirection: 'column', width: '387px' }}>
      <div
        style={{
          display: 'flex',
          height: '30px',
          paddingBottom: '10px',
          borderBottom: '1px solid #f0f0f0',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '6px',
          position: 'relative',
        }}
      >
        <div>图标选择</div>
        <div
          style={{ position: 'absolute', right: 0, cursor: 'pointer' }}
          onClick={() => {
            setOpenVisible(false)
          }}
        >
          <CloseOutlined />
        </div>
      </div>
      <div className={styles.popverConent}>
        {iconList?.map((v: any) => {
          return (
            <>
              <div
                className={styles.popverConentImgMain}
                onClick={() => {
                  setSelectIcon(v?.img)
                  setIconType(v?.type)
                  setTimeout(() => {
                    setOpenVisible(false)
                  }, 200)
                }}
              >
                <div
                  className={
                    v?.type == iconType
                      ? styles.popverConentImgSelect
                      : styles.popverConentImg
                  }
                >
                  <img
                    src={v?.img}
                    style={{ width: v?.width, height: v?.height }}
                  ></img>
                </div>
              </div>
            </>
          )
        })}
      </div>
    </div>
  )

  useEffect(() => {
    if (openVisible) {
      setIconType(modalSelectIconType)
    }
  }, [openVisible, modalSelectIconType])

  const JEQZContent = (
    <div>
      <div className={styles.imgWrap}></div>
      <div className={styles.text}>
        系统会为您计算一个四舍五入到1位小数的金额
      </div>
    </div>
  )

  return (
    <div className={styles.feeSettings}>
      <>
        <Form
          form={form}
          autoComplete='off'
          style={{ height: '100%' }}
          onFinish={(values) => {
            const payListNew = payList?.filter((l: any) => l != '')
            const num = 10 - Number(payListNew?.length)

            const selectResultList = selectResultLists?.filter(
              (items: any) => items?.value?.toString() == 'true'
            )
            if (selectResultList?.length > num) {
              notification.info({
                message: '支付方式最多勾选10个！',
              })
            } else if (values[Checks.FPXZ]?.length > 6) {
                notification.info({
                  message: '最多只能添加6个模板',
                })
                return
              }else {
              const pattern = /^[0-9]*$/

              const t = _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k: any) =>
                    ({
                      id: k,
                      status:
                        k == 2
                          ? 1
                          : v
                          ? 1
                          : 0,
                      methodName:
                        k == 1 || k == 2 || k == 3 || k == 4 || k == 5 || k == 6
                          ? getMethodName(k?.toString())
                          : paymentWayList?.find((v: any) => v?.id == k)
                              ?.methodName,
                      methodIcon:
                        k == 1 || k == 2 || k == 3 || k == 4 || k == 5 || k == 6
                          ? ''
                          : paymentWayList?.find((v: any) => v?.id == k)
                              ?.methodIcon,
                      sysMethodFlag : k == 1 || k == 2 || k == 3 || k == 4 || k == 5 || k == 6 ? true : false,
                    } as ChargeSetting)
                )
                .values()
                .value()
                ?.filter((v: any) => v?.type != '')
                ?.map((v: any) => {
                  return { ...v, status: v?.status }
                })

              const f = _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k) =>
                    ({
                      type: k,
                      value:
                        k === Checks.FPXZ.toString()
                          ? printFlag
                            ? v?.join(',')
                            : ''
                          : v?.toString(),
                    } as Settinglable)
                )
                .values()
                .value()

              const tenantSystemPayMethods = t
                ?.filter((v: any) => v?.sysMethodFlag === true)
                ?.map((v: any) => ({ status: v.status, methodType: v.id, methodName: v.methodName }))

              const tenantCustomizePayMethods = t?.filter((v) => {
                return v?.sysMethodFlag !== true && v?.methodName != undefined
              })

              const functions = f?.filter((v: any) => {
                return (
                  v?.type == Checks.Mrzffs ||
                  v?.type == Checks.JYYSKQ ||
                  v?.type == Checks.JEML ||
                  v?.type == Checks.FPXZ
                )
              })

              setButtonLoading(true)
              dispatch(
                getSaveFeesSettingAsync({
                  tenantSystemPayMethods: tenantSystemPayMethods,
                  tenantCustomizePayMethods: tenantCustomizePayMethods,
                  functions: functions,
                })
              )
                .then(unwrapResult)
                .then((v) => {
                  notification.success({
                    message: '保存成功,部分配置需要重新登陆后生效',
                    duration: 3,
                  })
                  getPage()
                  dispatch(getSettingDetail())
                })
                .finally(() => {
                  setButtonLoading(false)
                })
            }
          }}
        >
          <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              结算方式设置
            </Row>
            <Col
              className={styles.rowHeights}
              span={24}
              style={{ marginTop: '20px', display: 'flex' }}
            >
              <Col className={styles.titles}>支付方式 :</Col>
              <Col className={styles.rowHeights} style={{flex:1}}>
                <Row style={{width:'80%'}}>
                  <Col style={{ width: '20%' }}>
                    <Form.Item
                      name='1'
                      valuePropName='checked'
                      initialValue={true}
                    >
                      <Checkbox
                        onChange={(e) => {
                          // 取消勾选时，若该支付方式为当前默认支付方式，阻止取消
                          if (
                            !e?.target?.checked &&
                            Number(form.getFieldValue(Checks.Mrzffs)) === 1
                          ) {
                            notification.info({
                              message: '该支付方式为当前默认支付方式，无法取消',
                            })
                            form.setFieldsValue({ '1': true })
                            return
                          }
                          setFormChangeCheckBox(form.getFieldsValue())
                        }}
                      >
                        现金
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '20%' }}>
                    <Form.Item
                      name='4'
                      valuePropName='checked'
                      initialValue={true}
                    >
                      <Checkbox
                        onChange={(e) => {
                          // 取消勾选时，若该支付方式为当前默认支付方式，阻止取消
                          if (
                            !e?.target?.checked &&
                            Number(form.getFieldValue(Checks.Mrzffs)) === 4
                          ) {
                            notification.info({
                              message: '该支付方式为当前默认支付方式，无法取消',
                            })
                            form.setFieldsValue({ '4': true })
                            return
                          }
                          setFormChangeCheckBox(form.getFieldsValue())
                        }}
                      >
                        微信
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '20%' }}>
                    <Form.Item
                      name='3'
                      valuePropName='checked'
                      initialValue={true}
                    >
                      <Checkbox
                        onChange={(e) => {
                          // 取消勾选时，若该支付方式为当前默认支付方式，阻止取消
                          if (
                            !e?.target?.checked &&
                            Number(form.getFieldValue(Checks.Mrzffs)) === 3
                          ) {
                            notification.info({
                              message: '该支付方式为当前默认支付方式，无法取消',
                            })
                            form.setFieldsValue({ '3': true })
                            return
                          }
                          setFormChangeCheckBox(form.getFieldsValue())
                        }}
                      >
                        支付宝
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  {(JuheShow?.openHubPay == 1 ||
                    JuheShow?.openHubPayJiali == 1 ||
                    JuheShow?.openHubPayYinlian == 1 ||
                    JuheShow?.openHubPayKanglin == 1 ||
                    JuheShow?.openHubPayNew == 1) && (
                    <Col style={{ width: '20%' }}>
                      <Form.Item name='2'>
                        <Checkbox defaultChecked disabled>
                          聚合支付
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  )}
                  <Col style={{ width: '20%' }}>
                    <Form.Item
                      name='5'
                      valuePropName='checked'
                      initialValue={true}
                    >
                      <Checkbox
                        onChange={(e) => {
                          // 取消勾选时，若该支付方式为当前默认支付方式，阻止取消
                          if (
                            !e?.target?.checked &&
                            Number(form.getFieldValue(Checks.Mrzffs)) === 5
                          ) {
                            notification.info({
                              message: '该支付方式为当前默认支付方式，无法取消',
                            })
                            form.setFieldsValue({ '5': true })
                            return
                          }
                          setFormChangeCheckBox(form.getFieldsValue())
                        }}
                      >
                        银联
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  {props?.membersStatus != 0 && (
                    <Col style={{ width: '20%' }}>
                      <Form.Item
                        name='6'
                        valuePropName='checked'
                        initialValue={true}
                      >
                        <Checkbox
                          onChange={(e) => {
                            // 取消勾选时，若该支付方式为当前默认支付方式，阻止取消
                            if (
                              !e?.target?.checked &&
                              Number(form.getFieldValue(Checks.Mrzffs)) === 6
                            ) {
                              notification.info({
                                message: '该支付方式为当前默认支付方式，无法取消',
                              })
                              form.setFieldsValue({ '6': true })
                              return
                            }
                            setFormChangeCheckBox(form.getFieldsValue())
                          }}
                        >
                          会员
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  )}
                  {paymentWayList?.map((v: any) => {
                    return (
                      <>
                        <Col
                          style={{
                            width:
                              openEditName && v?.id == openEditId
                                ? ' 40% '
                                : '20%',
                          }}
                        >
                          <Row style={{ flexWrap: 'nowrap' }}>
                            <Col flex="0 0 24px" style={{ display: 'flex', alignItems: 'center' }}>
                              <Form.Item name={v?.id} valuePropName='checked'>
                                <Checkbox
                                  onChange={(e) => {
                                    // 取消勾选时，若该支付方式为当前默认支付方式，阻止取消
                                    if (!e?.target?.checked && form.getFieldValue(Checks.Mrzffs) === v?.id) {
                                      notification.info({
                                        message: '该支付方式为当前默认支付方式，无法取消',
                                      })
                                      form.setFieldsValue({ [v?.id]: true })
                                      return
                                    }
                                    const resultList: any = []
                                    const formSubmitData = form.getFieldsValue()
                                    for (const item in formSubmitData) {
                                      resultList.push({
                                        id: parseInt(item),
                                        value: formSubmitData[item],
                                      })
                                    }
                                    const selectResultList = resultList?.filter(
                                      (items: any) =>
                                        items?.value?.toString() == 'true' && items?.id > 10000
                                    )
                                    const payListNew = payList?.filter(
                                      (l: any) => l != ''
                                    )
                                    const num = 10 - Number(payListNew?.length)
                                    if (selectResultList?.length > num) {
                                      notification.info({
                                        message: '支付方式最多勾选10个！',
                                      })
                                    }
                                    setFormChangeCheckBox(form.getFieldsValue())
                                    setSelectResultLists(selectResultList)
                                  }}
                                ></Checkbox>
                              </Form.Item>
                            </Col>
                            <Col flex="auto">
                              <Form.Item>
                                {openEditName && v?.id == openEditId ? (
                                  <div style={{ display: 'flex' }}>
                                    <Input
                                      onChange={(e) => {
                                        setAddValue(e?.target?.value)
                                        setIconType(v?.methodIcon)
                                      }}
                                      maxLength={4}
                                      ref={inputRef}
                                      onClick={() => {
                                        inputRef.current?.select()
                                      }}
                                      defaultValue={v?.methodName}
                                      style={{
                                        width:
                                          openEditName && v?.id == openEditId
                                            ? '140px'
                                            : '112px',
                                        position: 'relative',
                                      }}
                                      placeholder='收费方式'
                                      suffix={
                                        <Popover
                                          content={content}
                                          title=''
                                          trigger='click'
                                          visible={openVisible}
                                          onVisibleChange={(visible) => {
                                            setOpenVisible(visible)
                                          }}
                                        >
                                          <img
                                            src={
                                              openEditName &&
                                              v?.id == openEditId
                                                ? selectIcon ||
                                                  getIconImg(v?.methodIcon) ||
                                                  morenImg
                                                : morenImg
                                            }
                                            style={{
                                              width: '100%',
                                              height: '20px',
                                            }}
                                            onClick={() => {
                                              setModalSelectIconType(
                                                v?.methodIcon
                                              )
                                            }}
                                          />
                                        </Popover>
                                      }
                                    />
                                    <CheckCircleOutlined
                                      style={{
                                        fontSize: 19,
                                        marginLeft: '10px',
                                        position: 'relative',
                                        top: 7,
                                        color: '#027AFF',
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => {
                                        setAddOrEditFlag(true)
                                      }}
                                    />
                                    <DeleteOutlined
                                      style={{
                                        color: 'red',
                                        fontSize: 19,
                                        marginLeft: '10px',
                                        position: 'relative',
                                        top: 7,
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => {
                                        if (v?.isUsed == 1) {
                                          notification.info({
                                            message:
                                              '该收费方式已被引用不可删除',
                                          })
                                        } else {
                                          Modal.confirm({
                                            title: '是否确认删除?',
                                            okText: '确认',
                                            cancelText: '取消',
                                            onOk: () => {
                                              dispatch(
                                                getPaymentWayListDelete(v?.id)
                                              )
                                                .then(unwrapResult)
                                                .then(() => {
                                                  notification.success({
                                                    message: '删除成功',
                                                    duration: 1,
                                                    onClose: () => {
                                                      getPage()
                                                    },
                                                  })
                                                })
                                            },
                                          })
                                        }
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <span
                                    onClick={() => {
                                      setAddPayTypeFlag(false)
                                      setOpenEditId(v?.id)
                                      setIconType(v?.methodIcon)
                                      setAddValue(v?.methodName)
                                      setSelectIcon('')
                                      setOpenVisible(false)
                                      setOpenEditName(true)
                                    }}
                                  >
                                    {v?.methodName}
                                  </span>
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      </>
                    )
                  })}
                  {!addPayTypeFlag && (
                    <Col span={4} className={styles.rowHeight}>
                      <PlusCircleOutlined
                        onClick={() => {
                          if (paymentWayList?.length == 10) {
                            notification.info({
                              message: '最多可添加10个支付方式！',
                            })
                          } else {
                            setOpenEditId('')
                            setOpenEditName(false)
                            setAddPayTypeFlag(true)
                            setSelectIcon('')
                            setOpenVisible(false)
                            // 清除之前的名称跟图标
                            setAddValue('')
                            setIconType('')
                          }
                        }}
                        style={{
                          color: '#2D7BFF',
                          fontSize: '20px',
                          marginTop: '6px',
                        }}
                      />
                    </Col>
                  )}
                  {addPayTypeFlag && (
                    <Col span={8} className={styles.rowHeight}>
                      <Input
                        style={{ width: '109px' }}
                        placeholder='收费方式'
                        maxLength={4}
                        onChange={(v) => {
                          setAddValue(v?.target?.value)
                        }}
                        suffix={
                          <Popover
                            content={content}
                            title=''
                            trigger='click'
                            visible={openVisible}
                            onVisibleChange={(visible) => {
                              setOpenVisible(visible)
                            }}
                          >
                            <img
                              src={selectIcon || morenImg}
                              style={{
                                width: '100%',
                                height: '20px',
                              }}
                            />
                          </Popover>
                        }
                      />
                      <CheckCircleOutlined
                        style={{
                          fontSize: 19,
                          marginLeft: '10px',
                          position: 'relative',
                          top: 3.5,
                          color: '#027AFF',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setOpenVisible(false)
                          setAddOrEditFlag(true)
                        }}
                      />
                      <CloseCircleOutlined
                        style={{
                          fontSize: 19,
                          marginLeft: '10px',
                          position: 'relative',
                          top: 3.5,
                          color: 'red',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setOpenVisible(false)
                          setAddPayTypeFlag(false)
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </Col>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='默认支付方式' name={Checks.Mrzffs}>
                <Radio.Group>
                  {(form.getFieldValue('1') ?? true) && (
                    <Radio key={1} value={1}>
                      现金
                    </Radio>
                  )}
                  {(form.getFieldValue('4') ?? true) && (
                    <Radio key={4} value={4}>
                      微信
                    </Radio>
                  )}
                  {(form.getFieldValue('3') ?? true) && (
                    <Radio key={3} value={3}>
                      支付宝
                    </Radio>
                  )}
                  {(JuheShow?.openHubPay == 1 ||
                    JuheShow?.openHubPayJiali == 1 ||
                    JuheShow?.openHubPayYinlian == 1 ||
                    JuheShow?.openHubPayKanglin == 1 ||
                    JuheShow?.openHubPayNew == 1) && (
                    <Radio key={2} value={2}>
                      聚合支付
                    </Radio>
                  )}
                  {(form.getFieldValue('5') ?? true) && (
                    <Radio key={5} value={5}>
                      银联
                    </Radio>
                  )}
                  {props?.membersStatus != 0 &&
                    (form.getFieldValue('6') ?? true) && (
                      <Radio key={6} value={6}>
                        会员
                      </Radio>
                    )}
                  {morenPayWayListData?.map((v: any) => {
                    return (
                      <>
                        <Radio key={v?.id} value={v?.id}>
                          {v?.methodName}
                        </Radio>
                      </>
                    )
                  })}
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Popover content={JEQZContent} placement='bottom' title='抹零'>
                <Form.Item
                  label='金额取整提示'
                  name={Checks.JEML}
                  valuePropName='checked'
                >
                  <Checkbox>开启</Checkbox>
                </Form.Item>
              </Popover>
            </Col>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              打印设置
            </Row>
            <div style={{ marginTop: '20px' }}>
              <Col className={styles.rowHeight} span={24} style={{ color: 'rgb(255, 131, 69)', marginLeft: '6px' }}>
                提示:结算后自动打印设置调整为每个账号一套配置，功能移到 管理设置-个人管理-个人设置
                {/* <Form.Item
                  label='结算后自动打印'
                  rules={[{ max: 256, message: '最大256位!' }]}
                >
                  <Switch
                    checked={printFlag}
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                    onChange={(v) => {
                      setPrintFlag(v)
                    }}
                  />
                </Form.Item>
                <Col span={16} style={{ marginLeft: '10px' }}>
                  <Form.Item
                    name={Checks.FPXZ}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Select
                      style={{ width: '70%' }}
                      className={styles.addtion}
                      mode='multiple'
                      showArrow
                      showSearch={false}
                    >
                      {templateList?.map((v: any) => (
                        <Option key={v?.templateId} value={v?.templateId}>
                          {v?.templateDesc}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col> */}
              </Col>
            </div>
            {code == '3301' && (
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '90%',
                }}
              >
                医保结算设置
              </Row>
            )}
            <div style={{ marginTop: '20px' }}>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='每次医保结算时校验医生考勤'
                  name={Checks.JYYSKQ}
                >
                  <Radio.Group>
                    <Radio value={'0'}>不校验</Radio>
                    <Radio value={'1'}>校验（需要前置机版本1.7.5及以上）</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </div>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              发票号设置
            </Row>
            <Col
              className={styles.rowHeight}
              span={24}
              style={{ marginTop: '20px' }}
            >
              <Form.Item label='发票号设置'>
                <Button
                  type='primary'
                  onClick={() => {
                    setInvoiceSettingVisible(true)
                    setTimeout(refreshInvoiceNumberView)
                  }}
                >
                  去设置
                </Button>
              </Form.Item>
            </Col>
          </div>

          <Row>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => {
                  getPage()
                }}
                style={{
                  float: 'right',
                  marginRight: '10px',
                }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{
                  float: 'left',
                }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
        <Modal
          title='发票号设置'
          visible={invoiceSettingVisible}
          confirmLoading={invoiceSettingLoading}
          onOk={() => {
            invoiceForm.submit()
          }}
          onCancel={() => {
            setInvoiceSettingVisible(false)
          }}
          width={720}
          maskClosable={false}
          destroyOnClose={false}
        >
          <Form
            form={invoiceForm}
            colon={false}
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 16 }}
            autoComplete='off'
            onFinish={handleInvoiceSettingFinish}
          >
            <Form.Item label='收费发票代码' name='aCode' {...required}>
              <Input />
            </Form.Item>
            <Form.Item
              label='收费发票号码'
              name='ano'
              rules={[{ required: true, message: ' ' }]}
              className={styles.input}
            >
              <Input.Group compact>
                <Form.Item
                  name={['ano', 'astart']}
                  rules={[
                    {
                      required: true,
                      message: '请输入收费发票号码',
                    },
                    {
                      pattern: /^\d+$/,
                      message: '请输入正确数字',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <span
                  style={{
                    margin: 5,
                  }}
                >
                  至
                </span>
                <Form.Item
                  name={['ano', 'aend']}
                  rules={[
                    {
                      required: true,
                      message: '请输入收费发票号码',
                    },
                    {
                      pattern: /^\d+$/,
                      message: '请输入正确数字',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item label='收费发票当前号码' name='acurrent' {...required}>
              <Input onChange={refreshInvoiceNumberView} />
            </Form.Item>
            <Form.Item
              label='发票位数'
              name='ainvoiceNumberLength'
              rules={[{ required: true, message: ' ' }]}
              className={styles.input}
            >
              <Input.Group compact>
                <Form.Item
                  name={['ainvoiceNumberLength']}
                  rules={[
                    {
                      required: true,
                      message: '请输入发票位数，若不设定固定长度则输入0',
                    },
                    {
                      pattern: /^(1[0-5]|[0-9])$/,
                      message: '请输入0-15之间的数字',
                    },
                  ]}
                >
                  <Input onChange={refreshInvoiceNumberView} />
                </Form.Item>
                <span
                  style={{
                    margin: 5,
                  }}
                >
                  实际打印号码：{invoiceNumberViewA}
                </span>
              </Input.Group>
            </Form.Item>
            <Form.Item label='挂号发票代码' name='bCode' {...numberRules}>
              <Input />
            </Form.Item>
            <Form.Item
              label='挂号发票号码'
              name='bno'
              className={styles.input}
            >
              <Input.Group compact>
                <Form.Item
                  name={['bno', 'bstart']}
                  rules={[
                    {
                      pattern: /^\d+$/,
                      message: '请输入正确数字',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <span
                  style={{
                    margin: 5,
                  }}
                >
                  至
                </span>
                <Form.Item
                  name={['bno', 'bend']}
                  rules={[
                    {
                      pattern: /^\d+$/,
                      message: '请输入正确数字',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item
              label='挂号发票当前号码'
              name='bcurrent'
              {...numberRules}
            >
              <Input onChange={refreshInvoiceNumberView} />
            </Form.Item>
            <Form.Item
              label='发票位数'
              name='binvoiceNumberLength'
              rules={[{ required: true, message: ' ' }]}
              className={styles.input}
            >
              <Input.Group compact>
                <Form.Item
                  name={['binvoiceNumberLength']}
                  rules={[
                    {
                      required: true,
                      message: '请输入发票位数，若不设定固定长度则输入0',
                    },
                    {
                      pattern: /^(1[0-5]|[0-9])$/,
                      message: '请输入1-15之间的数字',
                    },
                  ]}
                >
                  <Input onChange={refreshInvoiceNumberView} />
                </Form.Item>
                <span
                  style={{
                    margin: 5,
                  }}
                >
                  实际打印号码：{invoiceNumberViewB}
                </span>
              </Input.Group>
            </Form.Item>
          </Form>
        </Modal>
      </>
    </div>
  )
}